export const cyclistLinks = {
  GET_COUNTER_BAR: 'cyclist/counter',
  GET_DIRECTION_VIEW: 'cyclist/bydirection',
};

export const hikerLinks = {
  GET_COUNTER_BAR: 'hiker/counter',
};
